import React, { Component, createContext } from "react";
import { auth, firebaseDb } from "./firebase";
import alertify from "alertifyjs";

export const UserContext = createContext({ user: null });

const res = async (status) => {
  const adminS = firebaseDb.ref("admin");
  const ret = await adminS
    .get()
    .then((res) => {
      if (res.val().id === status.uid) {
        return true;
      }
    })
    .catch((err) => {
      auth.signOut();
      alertify.error("Unauthorized");
      return false;
    });

  return ret;
};

class UserProvider extends Component {
  state = {
    user: null,
  };

  componentDidMount = () => {
    auth.onAuthStateChanged((userAuth) => {
      if (userAuth != null) {
        const aks = res(userAuth);
        aks.then((res) => {
          if (res) {
            this.setState({ user: userAuth });
          }
        });
      } else {
        this.setState({ user: userAuth });
      }
    });
  };
  render() {
    return (
      <UserContext.Provider value={this.state.user}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}
export default UserProvider;
